import React from "react";
import GatsbyConfig from "../../../gatsby-config.js";
import BookmarkArrow from "../partials/bookmark-arrow";
import SiteFooter from "../partials/site-footer";
import SiteHeader from "../partials/site-header";
import TabbedContent from "../partials/tabbed-content";
import { getParamFromQueryString } from "../../utils/app-helpers";

const { siteMetadata: config } = GatsbyConfig;

const getTabObject = (data, version = "") => ({
  name: `${data.name} ${data.year}`,
  slug: `terms-${data.slug}${version}/`,
  component: `Terms${
    data.slug.charAt(0).toUpperCase() + data.slug.substr(1)
  }${version}`,
});

export default class PoliciesPage extends React.Component {
  render() {
    if (typeof document === "undefined" || typeof window === "undefined")
      return <main />;
    const { href } = window.location;
    const { pathname } = this.props.location;
    let { selectedKey } = this.props;
    if (!selectedKey) {
      selectedKey = pathname.match(/policies\/terms\-/i)
        ? pathname.replace(/.*policies\/(terms\-[\w\d\-]+).*/g, "$1")
        : "privacy";
    }

    const tabs = [
      {
        key: "privacy",
        name: "Privacy Policy",
        slug: "privacy/",
        component: "Privacy",
      },
    ];
    Object.keys(config.trips).forEach((key) => {
      const data = config.trips[key];
      if (!data.available) return;

      const version = data.termsVersion || "";
      const hideTab = !data.available && !data.showTerms;

      tabs.push({
        key,
        ...getTabObject(data),
        hideTab: hideTab || (!!version && selectedKey !== `terms-${key}`),
        active: selectedKey === `terms-${key}`,
      });
      if (version) {
        tabs.push({
          key: `${key}${version}`,
          ...getTabObject(data, version),
          hideTab: hideTab || selectedKey === `terms-${key}`,
          active: selectedKey === `terms-${key}${version}`,
        });
      }
    });

    const activeTab = tabs.find((tab) => tab.active);
    const activeTabKey = activeTab
      ? activeTab.key
      : this.props.selectedKey || tabs[0].key;

    const action = getParamFromQueryString("action", href);
    if (action === "print") setTimeout(window.print, 100);
    return (
      <div className="page-at-root page-policies">
        <div className="bookmark" id="top" />
        <SiteHeader lock />
        <main>
          <div
            style={{ backgroundImage: "url(/images/policies-splash.jpg)" }}
            className="image policies-splash mobile-100x40 desktop-300"
          />
          <TabbedContent
            willAnchor
            replaceState="/policies/"
            selectedKey={activeTabKey}
            data={JSON.stringify(tabs)}
          />
          <div className="wrap">
            <div className="content">
              <p>
                <sub>&copy; Copyright 2017-{new Date().getFullYear()}</sub>
              </p>
              <div className="arrow-bar">
                <BookmarkArrow bookmark="top" direction="up" />
              </div>
              {/* <p className="button-bar full">
                <a className="btn" onClick={print}>
                  Print &nbsp;
                  <i className="fa fa-print" />
                </a>
              </p> */}
            </div>
          </div>
        </main>
        <SiteFooter hidePolicies />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/policies.js